export default "__VITE_ASSET__8d93b742__"